import { ReleaseModule } from '@/config/releases';
import { useReleaseAnnouncements } from '@/hooks/useReleaseAnnouncements';
import { ReleaseAnnouncementModal } from './ReleaseAnnouncementModal';

interface ReleaseAnnouncementGateProps {
  releaseModule: ReleaseModule;
  enabled?: boolean;
}

export const ReleaseAnnouncementGate = ({
  releaseModule,
  enabled = true,
}: ReleaseAnnouncementGateProps) => {
  const {
    activeAnnouncement,
    activeIndex,
    announcements,
    isFirstAnnouncement,
    isLastAnnouncement,
    isOpen,
    isSaving,
    markBatchSeen,
    nextAnnouncement,
    previousAnnouncement,
  } = useReleaseAnnouncements(releaseModule, { enabled });

  const handleSeeAllUpdates = () => {
    const updatesUrl = activeAnnouncement?.updatesUrl;
    if (updatesUrl) {
      window.open(updatesUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ReleaseAnnouncementModal
      open={isOpen}
      announcement={activeAnnouncement}
      currentIndex={activeIndex}
      totalCount={announcements.length}
      isFirst={isFirstAnnouncement}
      isLast={isLastAnnouncement}
      isSaving={isSaving}
      onClose={() => {
        void markBatchSeen();
      }}
      onNext={nextAnnouncement}
      onPrevious={previousAnnouncement}
      onSeeAllUpdates={handleSeeAllUpdates}
    />
  );
};
